/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m13.3788966 3c.8940689 0 1.6211034.74063145 1.6211034 1.65142126v6.69715744c0 .9107898-.7270345 1.6514213-1.6211034 1.6514213h-10.75875867c-.89310345 0-1.62013793-.7406315-1.62013793-1.6514213v-6.69715744c0-.91078981.72703448-1.65142126 1.62013793-1.65142126zm0 8.5246385c.0955862 0 .1728275-.0786859.1728275-.1760598v-6.01455686l-5.09986203 4.15560145c-.13227586.1072096-.29158621.16130619-.45186207.16130619s-.32055172-.05409659-.45282759-.16130619l-5.09889655-4.15560145v6.01455686c0 .0973739.07724138.1760598.17186207.1760598zm-1.0929656-7.04927704h-8.57282755l4.28689655 3.49267237z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;